// JavaScript code for sn/mobile-header component
(($) => {

    "use strict";
    console.log("sn/mobile-header scripts loaded...");

    $('.sn-mobile-header .btn-mobile-menu').on('click', function () {
        $(this).toggleClass('active');
        $('.sn-mobile-header .sn-search-form-mobile').addClass('hidden');
        $('.sn-mobile-header .sn-menus-mobile-menu').toggleClass('hidden');
        $(document).trigger('sn:mobileMenuToggled', { isOpen: $(this).hasClass('active') });
    });

    $('.sn-mobile-header .btn-search').on('click', function () {
        $('.sn-mobile-header .btn-mobile-menu.active').click();
        $('.sn-mobile-header .sn-search-form-mobile').toggleClass('hidden');
    });


})(jQuery);